import { useState } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import NavBar from './NavBar';
import TopBar from './TopBar';
import Box from '@mui/material/Box';

interface DashboardLayoutProps {
  children?: ReactNode;
}

const DashboardLayout: FC<DashboardLayoutProps> = ({ children }) => {
  const [isMobileNavOpen, setMobileNavOpen] = useState<boolean>(false);
  const [isDesktopNavOpen, setDesktopNavOpen] = useState<boolean>(true);

  return (
    <Box
      sx={{
        backgroundColor: 'background.dark',
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <TopBar
        onMobileNavOpen={() => setMobileNavOpen(true)}
        onDesktopNavOpen={() => setDesktopNavOpen((prev) => !prev)}
      />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
        onDesktopClose={() => setDesktopNavOpen(true)}
        openDesktop={isDesktopNavOpen}
      />
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          overflow: 'hidden',
          paddingTop: '41px',
          pl: { lg: isDesktopNavOpen ? '256px' : 0 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flex: '1 1 auto',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              flex: '1 1 auto',
              height: '100%',
              overflow: 'auto',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
